import React, { useState } from 'react';
import { Base_Url, AppointmentBooking } from '../../../config/config';
import { toast } from 'react-toastify';
import { MdDelete } from 'react-icons/md';

const PARTNER_OPTIONS = [
  { value: 'delhivery', label: 'Delhivery' },
  { value: 'ecom_express', label: 'Ecom Express' },
  { value: 'ekart', label: 'Ekart' },
  { value: 'xpressbees', label: 'Xpressbees' },
  { value: 'bluedart', label: 'Bluedart' },
  { value: 'pickupxpress', label: 'Pickupxpress' },
];

export default function AppointmentModal({ isopen, onClose, orderId }) {
  const [formData, setFormData] = useState({
    orderId: orderId,
    appointmentDate: '',
    timeSlot: '',
    poNumbers: [''],
    poExpiryDate: '',
    appointmentId: '',
    partner: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isopen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePOChange = (index, value) => {
    const newPONumbers = [...formData.poNumbers];
    newPONumbers[index] = value;
    setFormData(prev => ({
      ...prev,
      poNumbers: newPONumbers
    }));
  };

  const addPOField = () => {
    setFormData(prev => ({
      ...prev,
      poNumbers: [...prev.poNumbers, '']
    }));
  };

  const removePOField = (index) => {
    if (formData.poNumbers.length > 1) {
      const newPONumbers = formData.poNumbers.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        poNumbers: newPONumbers
      }));
    }
  };

  const getTimeSlotValue = (slot) => {
    const timeSlotMap = {
      morning: '09:00 - 12:00 morning',
      evening: '14:00 - 18:00 evening',
      night: '18:00 - 21:00 night'
    };
    return timeSlotMap[slot] || slot;
  };

  const handleSubmit = async () => {
    const filteredPONumbers = formData.poNumbers.filter(po => po.trim() !== '');
    if (filteredPONumbers.length === 0) {
      setError('Please fill all the required fields');
      return;
    }

    if (!formData.partner) {
      setError('Please select a partner');
      return;
    }

    setLoading(true);

    try {
      const cusId = localStorage.getItem('cus_id');
      const token = localStorage.getItem('token');

      const payload = {
        order_id: orderId,
        start_date: formData.appointmentDate,
        end_date: formData.poExpiryDate,
        time_slot: getTimeSlotValue(formData.timeSlot),
        po_number: filteredPONumbers,
        appointment_id: formData.appointmentId || '',
        partner: formData.partner
      };

      const response = await fetch(Base_Url + AppointmentBooking, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          cus_id: cusId,
          token: token
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok || data.status === "success") {
        toast.success(data.message);
        onClose();
        setError('');
      } else {
        setError(data.message || 'Failed to register appointment');
      }

    } catch (err) {
      setError('Network error. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 pt-4 px-2">

      {/* Modal */}
      <div className="bg-white rounded-xl shadow-lg w-full max-w-[500px] max-h-[95vh] overflow-y-auto scrollbar-hide relative">
        {/* Header with Gradient */}
        <div className="flex items-center justify-between px-5 py-2 rounded-t-xl bg-gradient-to-r from-purple-500 via-pink-500 to-indigo-500 text-white">
          <h2 className="text-lg font-semibold">Register Appointment</h2>
          <button
            onClick={onClose}
            className="text-white text-xl hover:opacity-80"
          >
            ✕
          </button>
        </div>

        <div className="py-1.5 px-4">

          {/* Error */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded text-sm">
              {error}
            </div>
          )}

          {/* LRN */}
          <div className="grid grid-cols-2 gap-4">

            <div className="pb-1">
              <label className="text-sm font-normal text-gray-600">Order Id</label>
              <input
                type="text"
                value={orderId}
                disabled
                className="w-full mt-1 px-3 py-1 text-gray-400 border border-gray-200 rounded"
              />
            </div>
            {/* PO Numbers */}
            <div className="mt-1">
              <label className="text-sm font-normal text-gray-600">Enter PO</label>
              {formData.poNumbers.map((po, index) => (
                <div key={index} className="flex gap-2 mt-1">
                  <input
                    type="text"
                    value={po}
                    onChange={(e) => handlePOChange(index, e.target.value)}
                    className="flex-1 px-3 py-1 border rounded"
                    placeholder={`PO Number`}
                  />
                  {formData.poNumbers.length > 1 && (
                    <button
                      onClick={() => removePOField(index)}
                      className="px-3 py-1 text-red-600 border rounded"
                    >
                      <MdDelete />
                    </button>
                  )}
                </div>
              ))}
              {/* <button
              onClick={addPOField}
              className="mt-2 text-sm text-purple-600"
            >
              + Add Another PO
            </button> */}
            </div>
          </div>

          {/* Date + Slot */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-normal text-gray-600">Appointment Date</label>
              <input
                type="date"
                name="appointmentDate"
                value={formData.appointmentDate}
                onChange={handleInputChange}
                className="w-full mt-1 px-3 py-1 border border-gray-200 rounded"
              />
            </div>

            <div>
              <label className="text-sm font-normal text-gray-600">Select Slot</label>
              <select
                name="timeSlot"
                value={formData.timeSlot}
                onChange={handleInputChange}
                className="w-full mt-1 px-3 py-1 border rounded"
              >
                <option value="">Select Slot</option>
                <option value="morning">Morning (7 AM - 10 AM)</option>
                <option value="morning">Morning (10 AM - 2 PM)</option>
                <option value="evening">Evening (2 PM - 6 PM)</option>
                <option value="night">Night (6 PM - 9 PM)</option>
              </select>
            </div>
          </div>



          {/* Expiry */}
          <div className="grid grid-cols-2 gap-4">

            <div className="mt-1">
              <label className="text-sm font-normal text-gray-600">PO Expiry Date</label>
              <input
                type="date"
                name="poExpiryDate"
                value={formData.poExpiryDate}
                onChange={handleInputChange}
                className="w-full mt-1 px-3 py-1 border rounded"
              />
            </div>

            {/* Appointment ID */}
            <div className="mt-1">
              <label className="text-sm font-normal text-gray-600">Appointment ID (Optional)</label>
              <input
                type="text"
                name="appointmentId"
                value={formData.appointmentId}
                onChange={handleInputChange}
                className="w-full mt-1 px-3 py-1 border rounded"
              />
            </div>
          </div>

          {/* Partner */}
          <div className="grid grid-cols-2 gap-4">
            <div className="mt-1">
              <label className="text-sm font-normal text-gray-600">Partner</label>
              <select
                name="partner"
                value={formData.partner}
                onChange={handleInputChange}
                className="w-full mt-1 px-3 py-1 border rounded"
              >
                <option value="">Select Partner</option>
                {PARTNER_OPTIONS.map((p) => (
                  <option key={p.value} value={p.value}>{p.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end mt-2 gap-3">
            <button
              onClick={onClose}
              className="px-4 py-0.5 border rounded hover:bg-gray-100 hover:border-gray-500 bg-gray-100 border-gray-400 text-gray-600"
              disabled={loading}
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="px-4 py-0.5 bg-purple-600 text-white rounded hover:bg-purple-700"
            >
              {loading ? 'Registering...' : 'Register Appointment'}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}